/* eslint react/prop-types: 0 */
import React, { Component } from "react";

const FeatureFlagContext = React.createContext();
FeatureFlagContext.displayName = "FeatureFlagContext";
 
class FeatureFlagProvider extends Component {
  state = {
    featureFlags: []
  };
 
  componentDidMount() {    
    //TODO: Update with api call
    // axios.get("Feature/GetFeatures").then(res => { 
    //   this.setState({ featureFlags: res.data.featureStates });
    // }).catch(() => {}); 
  }
 
  render() {    
    return (
      <FeatureFlagContext.Provider
        value={{
          featureFlags: this.state.featureFlags
        }}
      >
        {this.props.children}
      </FeatureFlagContext.Provider>
    );
  }
}

const withFeatureManagement = (WrappedComponent) => {
  class withFeatureManagement extends React.Component {
    render() {
      return (
        <FeatureFlagContext.Consumer>
          {value => 
            <WrappedComponent {...this.props} featureFlags={value.featureFlags} />
          }
        </FeatureFlagContext.Consumer>
      );
    }
  }
  withFeatureManagement.displayName = `withFeatureManagement(${getDisplayName(WrappedComponent)})`;
  return withFeatureManagement;
};
   
function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || "Component";
}

export {FeatureFlagProvider, withFeatureManagement, FeatureFlagContext};